var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-field',{attrs:{"type":_vm.type,"size":_vm.size,"placeholder":_vm.placeholder,"maxlength":_vm.maxlength,"show-word-limit":_vm.showWordLimit,"autosize":_vm.autosize,"disabled":_vm.disabled,"input-align":_vm.inputAlign},on:{"blur":_vm.onBlur},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }